import { posthog } from "@/lib/posthog";
import { EVENTOS } from "./events";

/**
 * Métricas do balão de suporte no PostHog (CHAT002-4661, 25/09/2026).
 *
 * O Crisp mandava `crisp_chat_opened` e afins. Na troca para o Chatwoot
 * (CHAT002-4226) a normalização dos eventos ficou (`events.ts`), mas nada os
 * levava ao PostHog, e ficou impossível medir se o balão estava sendo usado
 * como suporte ou confundido com a IA (22–25% das conversas entre 17 e 24/09
 * pediam peça ou análise ao suporte).
 *
 * Escuta os CustomEvents normalizados, como o contador de não lidas: um
 * listener do SDK não comporta vários consumidores.
 *
 * Só a rota vai junto: nada do conteúdo da mensagem, nada de dado pessoal.
 */
let installed = false;

export function installSupportMetrics(): () => void {
	if (typeof window === "undefined" || installed) return () => {};
	installed = true;

	const currentRoute = () => window.location.pathname;
	const onOpened = () =>
		posthog.capture("support_chat_opened", {
			module: "support",
			route: currentRoute(),
		});
	const onMessageSent = () =>
		posthog.capture("support_message_sent", {
			module: "support",
			route: currentRoute(),
		});

	window.addEventListener(EVENTOS.aberto, onOpened);
	window.addEventListener(EVENTOS.enviada, onMessageSent);

	return () => {
		window.removeEventListener(EVENTOS.aberto, onOpened);
		window.removeEventListener(EVENTOS.enviada, onMessageSent);
		installed = false;
	};
}

/** Só para teste: devolve o módulo ao estado inicial. */
export function _resetSupportMetricsForTest(): void {
	installed = false;
}
